<template>
    <el-dialog title="数据匹配" width="50%"
               :close-on-click-modal="false"
               append-to-body :visible.sync="visible"
               class="haveTable">
        <div class="p_l1 p_r1" v-show="step == 1">
            <el-alert
                    title="使用说明"
                    type="warning"
                    description="请提前将资源文件上传至服务器目录" :closable="false">
            </el-alert>
            <el-form class="m_t1" size="small" :model="form" ref="form" label-width="100px" v-loading="loading">
                <el-form-item label="文件目录：" prop="matchPath"
                              :rules="{ required: true, message: '文件目录不能为空', trigger: 'change' }">
                    <div class="flex_b_c">
                        <el-select class="m_r2" v-model="form.matchPath" placeholder="请选择" clearable filterable>
                            <el-option
                                    :key="index"
                                    :label="item"
                                    :value="item"
                                    v-for="(item, index) in matchPathList">
                            </el-option>
                        </el-select>
                        <el-checkbox v-model="form.containSubDir" true-label="0" false-label="1">不包含子目录</el-checkbox>
                    </div>
                </el-form-item>
                <el-form-item label="匹配字段：" prop="matchFileds">
                    <el-button type="primary" @click="add()">新增</el-button>
                    <el-table size="small" :data="form.matchFileds" max-height="300" border class="m_t1">
                        <el-table-column type="index" label="序号" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <el-form-item class="p_t1">{{scope.$index + 1}}</el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column prop="fieldName" label="字段名">
                            <template slot-scope="scope">
                                <el-form-item class="p_t1" :prop="'matchFileds.' + scope.$index + '.basicId'"
                                              :rules="{ required: true, message: '字段名不能为空', trigger: 'change' }">
                                    <el-select v-model="scope.row.basicId" placeholder="请选择" clearable filterable
                                               @change="basicIdChange($event, scope.row)">
                                        <el-option
                                                :key="item.basicId"
                                                :label="item.basicName"
                                                :value="item.basicId"
                                                v-for="item in metadataField">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column prop="mode" label="匹配方式">
                            <template slot-scope="scope">
                                <el-form-item class="p_t1" :prop="'matchFileds.' + scope.$index + '.matchType'"
                                              :rules="{ required: true, message: '匹配方式不能为空', trigger: 'change' }">
                                    <el-radio-group v-model="scope.row.matchType">
                                        <el-radio label="0">精准匹配</el-radio>
                                        <el-radio label="1">模糊匹配</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="60">
                            <template slot-scope="scope">
                                <el-form-item class="p_t1">
                                    <el-button type="text" size="small" @click="del(scope.$index)">删除</el-button>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
            </el-form>
        </div>
        <div v-show="step == 2 || step == 3" class="el-table-container">
            <div class="numBox" v-if="step == 2">
                <div>待匹配资源数：
                    <el-link type="success" size="mini">{{matchCondition.totalNum}}条</el-link>
                </div>
                <div>已匹配资源数：
                    <el-link type="success" size="mini">{{matchCondition.successNum}}条</el-link>
                </div>
                <div>未匹配资源数：
                    <el-link type="danger" size="mini">{{matchCondition.failNum}}条</el-link>
                </div>
            </div>
            <div class="m_t1" v-if="step == 2">未匹配情况：
                <el-link type="primary" @click="exportData()">导出</el-link>
            </div>
            <el-table
                    :data="dataList"
                    size="small"
                    class="table" height="100%" border v-loading="loading">
                <el-table-column type="index" label="序号" v-if="step == 2"/>
                <el-table-column prop="metadataAttachments" label="已匹配文件" min-width="120" show-overflow-tooltip v-if="step == 3">
                    <template slot-scope="scope">
                        <span v-if="scope.row.metadataAttachments">{{scope.row.metadataAttachments.filePath}}</span>
                    </template>
                </el-table-column>
                <el-table-column v-for="(item, index) in tableList" :key="index"
                                 :prop="item.basicCode"
                                 :label="item.basicRename"
                                 show-overflow-tooltip v-if="item.disabled == '0'">
                    <template slot="header" slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="item.basicRename" placement="top-start">
                            <span class="omit">{{item.basicRename}}</span>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="step == 2">{{listDataFormat(item, scope.row.jsonData[item.basicCode])}}</span>
                        <span v-if="step == 3">{{listDataFormat(item, scope.row.metadataData.jsonData[item.basicCode])}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="未匹配情况" v-if="step == 2" width="120" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.jsonData.unMatchedInfo}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                        @pagination="getConditionList"/>
        </div>
        <el-result v-show="step == 4" icon="success" title="资源匹配成功" :subTitle="'成功匹配资源' + successNum + '个'">
            <template slot="extra">
                <el-button type="primary" size="small" @click="closeMatch()">关闭</el-button>
            </template>
        </el-result>
        <div slot="footer" class="text_center">
            <el-button size="small" v-if="step == 2" @click="step--">上一步</el-button>
            <el-button size="small" v-if="step == 3" @click="step = 1">重新数据匹配</el-button>
            <el-button size="small" type="primary" v-if="step == 1" @click="startMatching()" v-noMoreClick>开始匹配
            </el-button>
            <el-button size="small" type="primary" v-if="step == 2" @click="dataPreview()" v-noMoreClick>数据预览
            </el-button>
            <el-button size="small" type="primary" v-if="step == 3" @click="executionMatching()" v-noMoreClick>执行数据匹配
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
    import treeSelect from "@/components/treeSelect/treeSelect.vue";

    export default {
        components: {treeSelect},
        data() {
            return {
                visible: false,
                loading: false,
                step: 1,
                metadataField: [],
                form: {
                    configId: '',
                    basicDataId: '',
                    matchPath: '',
                    containSubDir: '1',
                    matchFileds: [],
                    selectArchivesDataElasticsearchDto: [],
                },
                matchPathList: [],
                matchCondition: {},
                tableList: [],
                dataList: [],
                total: 0,
                unMatchCacheKey: '',
                previewCacheKey: '',
                searchForm: {
                    current: 1,
                    size: 20,
                },
                successNum: 0
            }
        },
        methods: {
            init(configId, basicDataId, tableList, searchForm) {
                this.step = 1
                this.form.configId = configId
                this.form.basicDataId = basicDataId
                this.tableList = tableList
                this.form.selectArchivesDataElasticsearchDto = searchForm
                this.visible = true
                this.$nextTick(() => {
                    this.form.matchFileds = [];
                    this.$refs.form.resetFields();
                    this.getMatchFieldList()
                    this.getMatchPath()
                })
            },
            // 获取文件目录
            getMatchPath() {
                this.$axios(this.api.metadata.matchPaths).then(data => {
                    if (data.status) {
                        this.matchPathList = data.data
                    }
                })
            },
            // 获取匹配字段
            getMatchFieldList() {
                this.loading = true
                this.$axios(this.api.metadata.matchFieldList, {
                    configId: this.form.configId,
                    basicDataId: this.form.basicDataId
                }).then(data => {
                    if (data.status) {
                        this.metadataField = data.data
                    }
                    this.loading = false
                })
            },
            // 新增
            add() {
                this.form.matchFileds.push({
                    basicId: '',
                    basicName: '',
                    basicCode: '',
                    matchType: '',
                })
            },
            // 选择元数据字段
            basicIdChange(id, item) {
                let val = this.metadataField.filter(v => v.basicId == id)[0]
                this.$set(item, 'basicName', val.basicName)
                this.$set(item, 'basicCode', val.basicCode)
            },
            // 删除
            del(index) {
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.form.matchFileds.splice(index, 1);
                })
            },
            // 开始匹配
            startMatching() {
                if (!this.form.matchFileds.length) {
                    this.$message.error('请新增匹配字段')
                    return
                }
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.step++
                        this.getConditionList()
                    }
                })
            },
            // 获取匹配情况数据
            getConditionList() {
                this.loading = true
                this.$axios(this.api.metadata.startMatch, this.form, 'post').then(data => {
                    if (data.status) {
                        this.matchCondition = data.data
                        this.unMatchCacheKey = data.data.unMatchCacheKey
                        this.previewCacheKey = data.data.previewCacheKey
                        this.getUnMatchList()
                    } else {
                        this.loading = false
                    }
                })

            },
            // 获取未匹配情况数据
            getUnMatchList() {
                this.$axios(this.api.metadata.unMatchList, {unMatchCacheKey: this.unMatchCacheKey, ...this.searchForm}).then(data => {
                    if (data.status) {
                        this.dataList = data.data.data
                        this.total = parseInt(data.data.total)
                    } else {
                        this.$message.error(data.msg);
                    }
                    this.loading = false
                })
            },
            // 导出
            exportData() {
                this.exportExcel(this.api.metadata.unMatchListExport, {
                    basicDataId: this.form.basicDataId,
                    cacheKey: this.unMatchCacheKey,
                    fileName: '未匹配情况',
                }, '未匹配情况', 'post')
            },
            // 数据预览
            dataPreview() {
                if(this.matchCondition.successNum == 0) {
                    this.$message.warning('当前已匹配资源数为0条，请在上一步重新选择匹配条件')
                    return
                }
                this.loading = true
                this.$axios(this.api.metadata.previewList, {previewCacheKey: this.previewCacheKey, ...this.searchForm}).then(data => {
                    if (data.status) {
                        this.step++
                        this.dataList = data.data.data
                        this.total = parseInt(data.data.total)
                    } else {
                        this.$message.error(data.msg);
                    }
                    this.loading = false
                })
            },
            // 执行数据匹配
            executionMatching() {
                this.loading = true
                this.$axios(this.api.metadata.execDataMatch, {
                    basicDataId: this.form.basicDataId,
                    cacheKey: this.previewCacheKey,
                }, 'post').then(data => {
                    if (data.status) {
                        this.successNum = data.data.successNum
                        this.step++
                    } else {
                        this.$message.error('执行失败');
                    }
                    this.loading = false
                })

            },
            // 关闭
            closeMatch() {
                this.visible = false
                this.$emit("refreshData")
            },
        }
    }
</script>

<style scoped>
    .numBox {
        background: #f4f4f5;
        font-size: 12px;
        padding: 10px;
    }
</style>
